<script>
import appConfig from '@src/app.config'
import sampleData from '@src/sampleStudentData.json'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  studentListMethod,
  siteListMethod,
  authComputed,
  userListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Add Student',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      document: '',
      sampleData: sampleData,
      show: false,
      studentError: null,
      studentDataStatus: false,
      isStudentError: false,
      isStudentSuccess: false,
      isLoading: false,
      response: [],
      validResponse: [],
      siteconfiglist: [],
      platformId: 0,
      collegeName: '',
      collegelist: [],
      classlist: [],
      classlistData: [],
      collegeId: null,
      collegeClass: null,
      departmentId: null,
      departmentlist: [],
    }
  },
  computed: {
    ...authComputed,
    ...departmentComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    if (this.role === 'admin') {
      this.getListOfPlatform()
      this.getColleges()
    } else {
      this.platformId = this.profileData.platform_id
    }
    this.getDepartments()
    if (this.role !== 'admin') {
      this.platformId = this.profileData.platform_id
    }
    if (this.role === 'college') {
      this.collegeId = this.profileData.college_id
    } else if (this.role === 'teacher') {
      this.collegeClass = this.profileData.collegeClass
    } else if (this.role === 'administrator') {
      this.getColleges()
    }
  },
  methods: {
    ...studentListMethod,
    ...siteListMethod,
    ...userListMethod,
    ...departmentListMethod,
    uploadStudentFile() {
      this.isStudentError = false
      this.isStudentSuccess = false
      this.isLoading = true
      const Data = {
        document: this.document,
        college_id: this.collegeId,
        department: this.departmentId,
        collegeClass: this.collegeClass,
        platform_id: this.platformId,
      }
      this.addStudentInBulk({ Data })
        .then((resp) => {
          if (resp.errorArray.length !== 0) {
            this.isStudentError = true
            this.response = resp.errorArray
          }
          if (resp.valid.length !== 0) {
            this.isStudentSuccess = true
            this.validResponse = resp.valid
          }
          this.$refs['file'].reset()
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.$refs['file'].reset()
          var getError = new ErrorWrapper(error)
          this.studentError = getError.message
        })
    },

    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          // listitems.push({value:'All', text: 'All'})
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getRole() {
      if (this.platformId === 0) {
        this.collegeId = 0
      } else {
        this.collegeId = this.platformId
      }
      let i = 0
      for (i = 0; i < this.siteconfiglist.length; i++) {
        if (this.platformId === this.siteconfiglist[i].value) {
          this.platform = this.siteconfiglist[i].text
          this.collegeName = this.siteconfiglist[i].text
        }
      }
    },
    handleFileUpload(event) {
      var files = event.target.files || event.dataTransfer.files
      const reader = new FileReader()
      reader.readAsDataURL(files[0])
      reader.onload = () => {
        this.document = reader.result
      }
    },
    getColleges() {
      this.collegeId = null
      this.fetchCollegeList()
        .then((college) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select College',
            disabled: true,
          })
          college.forEach((element) => {
            if (element.platform_id === this.platformId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.collegelist = listitems
        })
        .catch((_error) => {})
    },

    getClasses() {
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select Class',
            disabled: true,
          })
          classes.forEach((element) => {
            var ele = {}
            if (this.departmentId === element.department) {
              ele.text = element.name
              ele.value = element._id
              ele.college = element.college_id
              listitems.push(ele)
            }
          })
          this.classlist = listitems
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select Department',
            disabled: true,
          })
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },

    selectClass() {
      this.classlist = []
      this.collegeClass = null
      var i = 0
      this.classlist.push({
        value: null,
        text: 'Select Class',
        disabled: true,
      })
      for (i = 0; i < this.classlistData.length; i++) {
        if (this.classlistData[i].college === this.collegeId) {
          this.classlist.push({
            value: this.classlistData[i].value,
            text: this.classlistData[i].text,
          })
        }
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            <b-alert
              v-if="validResponse !== undefined"
              v-model="isStudentSuccess"
              variant="success"
            >
              <div
                v-for="(item1, index1) in validResponse"
                :key="`list${index1}`"
              >
                <p v-if="index1 + 1 === validResponse.length">{{ item1 }}</p>
                <p v-else>{{ item1 }},</p>
              </div>
            </b-alert>
            <b-alert
              v-if="response !== undefined"
              v-model="isStudentError"
              variant="danger"
            >
              <div v-for="(item1, index1) in response" :key="`list${index1}`">
                <p v-if="index1 + 1 === response.length">{{ item1 }}</p>
                <p v-else>{{ item1 }},</p>
              </div>
            </b-alert>
            <b-form @submit.prevent="uploadStudentFile">
              <b-form-group label="Upload Student File" label-for="document">
                <b-form-file
                  id="document"
                  ref="file"
                  type="file"
                  required
                  placeholder="Click here to add file"
                  accept=".csv"
                  @change="handleFileUpload"
                ></b-form-file>
              </b-form-group>
              <b-form-group
                v-if="role === 'admin'"
                label="Select Platform*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="platformId"
                  :options="siteconfiglist"
                  @change="getColleges"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                v-if="role === 'administrator' || role === 'admin'"
                label="Select College*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="collegeId"
                  :options="collegelist"
                  @change="getDepartments"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Select Department*" label-for="input-1">
                <b-form-select
                  v-model="departmentId"
                  :options="departmentlist"
                  required
                  oninvalid="this.setCustomValidity('Please Select Department')"
                  oninput="this.setCustomValidity('')"
                  @change="getClasses"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Select Class*" label-for="input-1">
                <b-form-select
                  v-model="collegeClass"
                  :options="classlist"
                  required
                  oninvalid="this.setCustomValidity('Please Select Class')"
                  oninput="this.setCustomValidity('')"
                ></b-form-select>
              </b-form-group>

              <b-form-group id="button-group" class="mt-2">
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-block button"
                  >Upload</b-button
                >
              </b-form-group>
            </b-form>
            <b-btn>
              <download-excel :data="sampleData" type="csv" :name="'sample.csv'"
                >Download Sample Data</download-excel
              > </b-btn
            ><br /><br />
            <a class="cancel-anchor" href="/student-list"
              ><b-button
                v-if="!isLoading"
                class="cancel"
                type="button"
                variant="primary"
                >Cancel</b-button
              ></a
            >
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.vue-tags-input {
  max-width: 100% !important;
}

.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  font-size: inherit !important;
  font-weight: inherit !important;
}
</style>
